import template from './myConnectButton.template.html';
import templateRefer from './myConnect.template.html';

export default {
  template,
  bindings: {
    contacts: '<',
    addresses: '<',
    owner: '<',
    idTicket: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, myConnectService, uiService, Address) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;

      ctrl.initialize = () => {
        ctrl.contacts = _.filter(ctrl.contacts || [], (c) => !c?.isCompany);
        ctrl.clients = ctrl.contacts.slice(0, 2);
        ctrl.addresses = ctrl.addresses || [];
        ctrl.owner = ctrl.owner || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.openDialog = ($event) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              contacts: ctrl.clients || [],
              addresses: ctrl.addresses || [],
              owner: ctrl.owner || {},
              idTicket: ctrl.idTicket || ''
            },
            template: templateRefer,
            controllerAs: '$ctrl',
            multiple: true,
            controller(contacts, addresses, owner, idTicket) {
              const self = this;
              self.contacts = contacts;
              self.addresses = addresses;
              self.owner = owner;
              self.idTicket = idTicket;
              self.errorMessages = [];
              self.hasError = false;
              self.isLoading = false;
              self.relocationAddress = new Address(self.addresses[0]);

              self.addSelectedAddress = (address) => {
                self.relocationAddress = address;
              };

              self.getRelocationAddress = (address) =>
                address
                  ? Address.getAddress(address)
                  : Address.getAddress(self.relocationAddress);

              self.canRefer = () => Address.hasAddress(self.relocationAddress);

              if (!self.canRefer()) {
                self.hasError = true;
                self.errorMessages.push('Relocation address is required, please select one.');
                if (!self.addresses?.length) {
                  self.errorMessages.push('Currently, there are no securities.');
                }
              }

              self.confirm = () => {
                if (self.canRefer()) {
                  self.errorMessages = [];
                  self.hasError = false;
                  self.isLoading = true;
                  myConnectService
                    .refer({
                      idTicket: self.idTicket,
                      relocationAddress: self.relocationAddress
                    })
                    .then((result) => {
                      self.isLoading = false;
                      if (result?.status) {
                        $mdDialog.hide(true);
                      } else {
                        self.hasError = true;
                        if (result?.errors?.length) {
                          const len = result?.errors?.length || 0;
                          for (let e = 0; e < len; e += 1) {
                            const error = result?.errors[e];
                            const message = error?.label
                              ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                              : error?.message || error || '';
                            self.errorMessages.push(message);
                          }
                        } else {
                          self.errorMessages.push(result?.errorMessage);
                        }
                        self.errorMessages.unshift('MyConnect errors:');
                      }
                    });
                }
              };

              self.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            uiService.toast({
              text: {
                p1: 'Application',
                p2: 'has been successfully',
                p3: 'submitted'
              },
              success: true
            });
            ctrl.onFinished({ status: result });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
